import axios from "axios";
import { toast } from "sonner";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return d.message || JSON.stringify(d);
};

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 402) {
      toast.error(errMsg(e), {
        action: { label: "Upgrade", onClick: () => (window.location.href = "/dashboard/settings/billing") },
      });
      e._handled = true;
    }
    return Promise.reject(e);
  }
);

export const notifyErr = (e) => { if (!e?._handled) toast.error(errMsg(e)); };
export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/files", fd);
  return data.url;
}

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(typeof s === "number" ? s * 1000 : s);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};
export const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return `${fmtDate(s)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
export const aud = (n) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n || 0);

export function download(blob, name) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}

export async function downloadApi(path, name) {
  const { data } = await api.get(path, { responseType: "blob" });
  download(data, name);
}
